'use strict';

module.exports = {
    openCashier: {
        service: 'Pay',
        action: 'callPay',
        tagname: 'call_pay',
        optHandle: function optHandle(opt) {
            return {
                path: 'payment2',
                names: ["payment_route_" + opt.bustype],
                param: 'index.html#index?' + Object.keys(opt).map(function (key) {
                    return key + '=' + opt[key];
                }).join('&')
            };
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../plugins/ctrip/apis/pay.js
// module id = 52
// module chunks = 1 4